// test68
(68 && 0);
